// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card[data-v-0d79472b]{border-radius:0;border-width:1px;cursor:pointer;padding:1.25rem;text-align:center;text-decoration-line:none;transition-duration:.15s}.card[data-v-0d79472b]:not(:last-child){margin-right:-1px}.card[data-v-0d79472b]:hover{border-radius:.25rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
